import React, {PropTypes} from 'react';
import Data from './post_a_shipment_data'
import './post_a_shipment_intro.less';
import {Link, browserHistory} from 'react-router';
import LoggedinFooter from '../../footer/loggedin_footer';
import {routerActions} from 'react-router-redux';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import postAShipmentActions from '../post_a_shipment_actions'
import CONSTANTS from '../../common_constants';

class PostAShipmentInto extends React.Component {
  constructor(props) {
    super(props);
    window.scrollTo(0,0);
  }
  startPostAShipment = ()=>{

    const {userData} = this.props.authState;
    if(userData.email) amplitude.getInstance().setUserId(userData.email);
    amplitude.getInstance().logEvent(CONSTANTS.AMPLITUDE_EVENTS.POST_ITEM_START);

    this.props.postAShipmentActions.clearPostAShipmentDetails();
    browserHistory.push('/post-a-shipment/upload-photo');
  }
  render() {
    return (
      <div id="postaShipmentWrap">
        <div className="post-a-shipment-into-wrap  wrapper">
          <div className ="post-a-shipment-section">
            {
              Data.map((item , index)=>{
                return(
                    <div key ={index} className = "data-map-wrapper">
                      <div className= {index == 0 ? "post-a-shipment-intro first-elem" : "post-a-shipment-intro"}>
                        <div className ="intro-img">
                            <span className={item.className}></span>
                        </div>
                        <div className ="intro-content">
                          <div className = "heading">{item.header}</div>
                          <div className = "sub-heading">{item.subHeading}</div>
                        </div>
                      </div>
                      { //last item doesnt get the line-dot-section
                        (index < 4) && <div className ="line-dot-section" >
                          <div className="line-dot">
                            <span className="icon-icn_line_dot"></span>
                          </div>
                          <div className="line-dot">
                            <span className="icon-icn_line_dot"></span>
                          </div>
                          <div className="line-dot">
                            <span className="icon-icn_line_dot"></span>
                          </div>
                        </div>
                      }
                    </div>
                )
              })
            }
          <div className= "start-btn-section">
            <button className ="btn orange into-btn" onClick = {this.startPostAShipment}>Start</button>
          </div>
        </div>
        </div>
        <LoggedinFooter />
      </div>

    )
  }
}

PostAShipmentInto = connect((state) => {
  return {
    postAShipment : state.app.postAShipment,
    authState : state.app.auth
  }
}, (dispatch) => {
  return {
    routerActions: bindActionCreators(routerActions, dispatch),
    postAShipmentActions :bindActionCreators(postAShipmentActions, dispatch)
  }
})(PostAShipmentInto);

export default PostAShipmentInto;



// WEBPACK FOOTER //
// app/post_a_shipment/post_a_shipment_intro/post_a_shipment_intro.jsx